import React, { Component } from "react";
import t from "i18n";
import { formatAmount } from "../../../../services/utils";
import { CommonLoader } from "../../../common/CommonLoader";
import { isArray } from "lodash";

class PaperInscriptionsCASilo extends Component {

  getRandomColor() {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  formatData = (data) => {
    const { activeTabTypeSilo } = this.props;
    const result = {};

    Object.values(data).forEach(monthData => {
      Object.values(monthData).forEach(silot => {
        const { silotId, silotName, individuelNbrInscrit, individuelCa, fiduciareNbrInscrit, fiduciareCa, color } = silot;

        if (!result[silotId]) {
          result[silotId] = {
            silotId,
            silotName,
            totalNbrInscrit: 0,
            totalCa: 0,
            color,
          };
        }

        result[silotId].totalNbrInscrit += individuelNbrInscrit + fiduciareNbrInscrit;
        result[silotId].totalCa += individuelCa + fiduciareCa;
      });
    });

    return result;

  };


  render() {
    const { data, handleToggleKey, visibleKeys, silotDataFetch } = this.props;
    const formattedData = this.formatData(data);

    const getGlobalTotals = (formattedData) => {
      return Object.values(formattedData).reduce(
        (acc, silot) => {
          acc.totalNbrInscrit += silot.totalNbrInscrit;
          acc.totalCa += silot.totalCa;
          return acc;
        },
        {
          totalNbrInscrit: 0,
          totalCa: 0,
        }
      );
    }

    const globalTotals = getGlobalTotals(formattedData);

    const totalNbr = globalTotals.totalNbrInscrit;
    const totalCa = globalTotals.totalCa;

    const { } = this.props;
    return (
      <div style={{ width: '50%', display: 'flex', flexDirection: 'column', gap: '20px' }}>
        <div style={{
          background: "#F9FAFB",
          padding: "20px",
          borderRadius: "10px",
          width: "100%",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
        }}>
          {silotDataFetch ? <CommonLoader containerHeight={"300px"} iconFontSize={"50px"} iconColor={"#29394D"} /> :
            (
              <React.Fragment>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "10px 0",
                    fontSize: "14px",
                    color: "#29394D",
                    borderBottom: "1px solid #D8DDE2",
                  }}
                >
                  <span style={{ width: "35%" }}></span>
                  <span style={{ width: "30%", textAlign: "end" }}>
                    Inscription
                  </span>
                  <span style={{ width: "30%", textAlign: "end" }}>C.A</span>
                  <span style={{ width: "5%" }}></span>
                </div>

                {Object.entries(formattedData)
                  .sort(([, a], [, b]) => b.totalNbrInscrit - a.totalNbrInscrit)
                  .map(([silotId, silot]) => {

                  const { silotName, totalNbrInscrit, totalCa, color } = silot;

                  return (
                    <React.Fragment key={silotId}>
                      <div style={{ padding: "10px 0", opacity: visibleKeys.includes(Number(silotId)) ? 1 : 0.5, borderBottom: "1px solid #D8DDE2", }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              width: "35%",
                            }}
                          >
                            <span
                              style={{
                                width: "8px",
                                height: "8px",
                                borderRadius: "40%",
                                backgroundColor: color,
                              }}
                            ></span>
                            <span
                              style={{
                                fontWeight: "500",
                                fontSize: "16px",
                                color: "#29394D",
                                textTransform: "capitalize",
                              }}
                            >
                              {silotName}
                            </span>
                          </div>
                          <span
                            style={{
                              fontWeight: "500",
                              color: color,
                              width: "30%",
                              textAlign: "end",
                            }}
                          >
                            {totalNbrInscrit}
                          </span>
                          <span
                            style={{
                              fontWeight: "500",
                              color: color,
                              width: "30%",
                              textAlign: "end",
                            }}
                          >
                            {formatAmount(totalCa)}
                          </span>
                          <span
                            style={{ width: "5%", display: "flex", justifyContent: "center", cursor: "pointer" }}
                            onClick={() => handleToggleKey(Number(silotId))}
                          >
                            <img src={visibleKeys.includes(Number(silotId)) ? "/img/icons/event-stats/eye-2.svg" : "/img/icons/event-stats/eye-1.svg"} alt="" />
                          </span>
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}

                <div
                  style={{
                    borderTop: "1px solid #29394D",
                    marginTop: "25px",
                    paddingTop: "12px",
                    fontWeight: "700",
                    color: "#29394D",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontSize: "16px",
                  }}
                >
                  <span style={{ width: "35%" }}>Total</span>
                  <span style={{ width: "30%", textAlign: "end" }}>{totalNbr}</span>
                  <span style={{ width: "30%", textAlign: "end" }}>{formatAmount(totalCa)}</span>
                  <span style={{ width: "5%" }}></span>
                </div>
              </React.Fragment>
            )}
        </div>
      </div>
    );
  }
}

export default PaperInscriptionsCASilo;



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/PaperInscriptionsCASilo.js